// extracted by mini-css-extract-plugin
module.exports = {"container":"loginContainer-module-container--kDeex","form":"loginContainer-module-form--e2Lx1","forgotPassword":"loginContainer-module-forgotPassword--yy843"};